'use client'

import { type ReactNode } from 'react'
import { useEffect } from 'react'
import { useDupeInputStore } from '~/src/stores/dupeInputStore'

export function DupeInputStoreProvider({ children }: { children: ReactNode }) {
  const checkAndResetDaily = useDupeInputStore(
    (state) => state.checkAndResetDaily
  )

  // Check for daily reset when the provider mounts
  useEffect(() => {
    checkAndResetDaily()
  }, [checkAndResetDaily])

  return <>{children}</>
}
